[
  {
    "slug": "work-games",
    "title": "Build a playable video game",
    "description": "Build Star Collector, play it in the code artifact, point to changes, and download your game.",
    "icon": "gamepad",
    "minutes": 18,
    "output": "A playable HTML game"
  },
  {
    "slug": "work-images",
    "title": "Create and edit an image",
    "description": "Make a game cover, select an area in the image artifact, remove distractions, and create a new format.",
    "icon": "image",
    "minutes": 12,
    "output": "An image and a revised version"
  },
  {
    "slug": "work-documents",
    "title": "Make an editable document",
    "description": "Turn a brief into a formatted document, edit it directly, and check Word and PDF exports.",
    "icon": "file-lines",
    "minutes": 12,
    "output": "An editable guide, DOCX, and PDF"
  },
  {
    "slug": "work-spreadsheets",
    "title": "Build a working spreadsheet",
    "description": "Create a launch budget, test formulas with a known answer, edit cells, and export your workbook.",
    "icon": "table",
    "minutes": 14,
    "output": "An editable workbook and XLSX"
  },
  {
    "slug": "work-presentations",
    "title": "Create a presentation",
    "description": "Build a five-slide pitch, edit the slides and speaker notes, rehearse, and export.",
    "icon": "chalkboard",
    "minutes": 12,
    "output": "An editable deck, PPTX, and PDF"
  },
  {
    "slug": "work-videos",
    "title": "Make a video, step by step",
    "description": "Plan a three-shot trailer, review reference media and clips, revise a shot, and export your video.",
    "icon": "film",
    "minutes": 20,
    "output": "A reviewed video project and MP4"
  }
]
